import { prepareBaseResponse } from "./prepareBaseResponse";
import { MessageTypes } from "../messageTypesEnum";
import { prepareMatchSummaryForWatch } from "../../matchService";
import * as Sentry from "@sentry/react";
import { MatchSummary } from "refsix-js-models";
import { WatchMessage } from "../watchInterface";

interface MatchesSummaryResponse extends WatchMessage {
    matches: MatchSummary[];
}

export async function getMatchesSummaryMessage(
    data: any,
    token: any
): Promise<MatchesSummaryResponse | undefined> {
    const message = {
        requestId: data.id,
        matches: [],
    };

    // TODO version mismatch?
    // if (data.version && $rootScope.versionNumber !== data.version) {
    //     _sendVersionMismatchMessage(message, data);
    // } else {

    try {
        const response: any = prepareBaseResponse(
            message,
            MessageTypes.GET_MATCHES_SUMMARY_RESPONSE,
            data,
            token
        );
        let matches = prepareMatchSummaryForWatch();

        return { ...response, matches };
    } catch (error: any) {
        Sentry.captureMessage(
            `[WatchService._handleMatchList()] Problem building match list 
                ${error.message}`
        );
        return undefined;
    }
}
